import styles from '../watermark.module.css';

const ControlBox = (props: { children?: React.ReactNode }) => {
  return (
    <div className={styles.controlBox}>
      <div id="rotate-node" className={styles.rotateNode}></div>
      <div id="top-left-node" className={styles.topLeftNode}></div>
      <div id="top-right-node" className={styles.topRightNode}></div>
      <div id="bottom-right-node" className={styles.bottomRightNode}></div>
      <div id="bottom-left-node" className={styles.bottomLeftNode}></div>
      {props.children}
    </div>
  );
};

export default ControlBox;
